import { gql } from "@apollo/client";

const FEATURED_LEAGUES = gql`
  query featuredLeagues($filter: ListLeagueInput, $sports: [Int!]) {
    featuredLeagues(filter: $filter, sports: $sports)
  }
`;

export default FEATURED_LEAGUES;
